import { render, staticRenderFns } from "./PriceFixed.vue?vue&type=template&id=165f629a&scoped=true&"
import script from "./PriceFixed.vue?vue&type=script&lang=js&"
export * from "./PriceFixed.vue?vue&type=script&lang=js&"
import style0 from "./PriceFixed.vue?vue&type=style&index=0&id=165f629a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165f629a",
  null
  
)

export default component.exports